/// <reference lib="dom" />
import * as d3 from "d3";
import type { ChartLayer, ChartScale } from "../core/chart.ts";
import { ScaleIn } from "./shared.ts";
import type { LineDatum } from "./lines.ts";

export interface AreaSeries {
  id: string;
  points: LineDatum[];
  base?: number;
  color?: string;
  opacity?: number;
}

export interface AreaLayerOpts {
  id?: string;
  y?: ChartScale;
}

export interface AreaLayer extends ChartLayer {
  set(series: AreaSeries[]): void;
}

export function AreaLayer(opts: AreaLayerOpts = {}): AreaLayer {
  let series: AreaSeries[] = [];
  const area = d3.area<LineDatum>();
  return {
    id: opts.id ?? "areas",
    clip: true,
    set(next) {
      series = next;
    },
    render(root, ctx) {
      const y = ScaleIn(ctx, "y", opts.y);
      root.selectAll<SVGPathElement, AreaSeries>("path")
        .data(series, (s) => s.id)
        .join("path")
        .attr("fill", (s) => s.color ?? ctx.theme.series)
        .attr("fill-opacity", (s) => s.opacity ?? ctx.theme.fillOpacity)
        .attr("stroke", "none")
        .style("pointer-events", "none")
        .attr("d", (s) => {
          const base = y(s.base ?? y.domain()[0]);
          area.x((p) => ctx.x(p.x)).y0(base).y1((p) => y(p.y));
          return s.points.length ? area(s.points) : null;
        });
    },
  };
}
